import React from 'react';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import { getPartner } from '../../../../../../lib/access.es6';
import PolicyInfoHeader from '../../shared/Components/PolicyInfoHeader';
import PremiumComparisonBox from '../../shared/Components/PremiumComparisonBox';
import AmendmentPageHeader from '../../shared/Components/AmendmentPageHeader';

/**
 * Screen for downgrade (Member & Family → Member Only)
 * Shows remaining Principal and members to be removed with promote action
 */
const DowngradeSelectionScreen = ({
  selectedPrincipal,
  removedMembers,
  currentCoverageType,
  targetCoverageType,
  currentPlan,
  originalTotalPremium,
  policy,
  canPromoteCheck,
  onPromoteToPrincipal,
  onNext,
  onCancel
}) => {
  const currencyCode = getPartner().country.currency_code;

  // Calculate new premium
  const remainingPremium = selectedPrincipal ? (selectedPrincipal.premium_amount_in_cents || 0) : 0;

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <AmendmentPageHeader
        title="Change Coverage Type"
        subtitle="Select which member will remain as Principal"
        onBack={onCancel}
      />

      {/* Policy Information */}
      <PolicyInfoHeader policy={policy} />

      {/* Premium Comparison */}
      <PremiumComparisonBox
        oldPremium={originalTotalPremium}
        newPremium={remainingPremium}
        oldLabel={`Original Premium (${currentCoverageType})`}
        newLabel={`New Premium (${targetCoverageType})`}
      />

      {/* Remaining Principal Table */}
      {selectedPrincipal && (
        <section style={{ marginBottom: '30px' }}>
          <h6 style={{
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '15px',
            color: '#032A37'
          }}>
            Remaining Principal
          </h6>
          <table style={{
            width: '100%',
            background: '#FFFFFF',
            border: '1px solid #A7A7A7',
            borderCollapse: 'collapse'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #A7A7A7' }}>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'left'
                }}>Member Name</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>Relationship</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>DOB</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>Benefits</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'right'
                }}>Premium</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderTop: '1px solid #A7A7A7' }}>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>
                  {selectedPrincipal.first_name} {selectedPrincipal.last_name}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>
                  Principal
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>
                  {new Date(selectedPrincipal.date_of_birth).toLocaleDateString()}
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>
                  <ul style={{ margin: 0, paddingLeft: 0, listStyle: 'none' }}>
                    {selectedPrincipal.benefits && selectedPrincipal.benefits.map((benefit, i) => (
                      <li key={i} style={{ marginBottom: '4px' }}>
                        {benefit.type.toLowerCase()}{' '}
                        <strong>
                          {currencyCode} {((benefit.cover_amount_in_cents || 0) / 100).toLocaleString()}
                        </strong>
                      </li>
                    ))}
                  </ul>
                </td>
                <td style={{
                  fontFamily: 'open sans',
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'right',
                  fontWeight: '600'
                }}>
                  {currencyCode} {(remainingPremium / 100).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      )}

      {/* Other Members (Will be removed) Table */}
      {removedMembers.length > 0 && (
        <section style={{ marginBottom: '30px' }}>
          <h6 style={{
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '15px',
            color: '#032A37'
          }}>
            Other Members (Will be removed)
          </h6>
          <table style={{
            width: '100%',
            background: '#FFFFFF',
            border: '1px solid #A7A7A7',
            borderCollapse: 'collapse'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #A7A7A7' }}>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'left'
                }}>Member Name</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>Relationship</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>DOB</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'right'
                }}>Premium</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {removedMembers.map((member, index) => {
                const eligibilityCheck = canPromoteCheck(member);
                const canPromote = eligibilityCheck.valid;

                return (
                  <tr key={member.uuid || index} style={{ borderTop: '1px solid #A7A7A7' }}>
                    <td style={{
                      fontFamily: 'open sans',
                      fontSize: '12px',
                      color: '#000000',
                      padding: '10px',
                      borderRight: '1px solid #A7A7A7'
                    }}>
                      {member.first_name} {member.last_name}
                    </td>
                    <td style={{
                      fontFamily: 'open sans',
                      fontSize: '12px',
                      color: '#000000',
                      padding: '10px',
                      borderRight: '1px solid #A7A7A7'
                    }}>
                      {member.relationship}
                    </td>
                    <td style={{
                      fontFamily: 'open sans',
                      fontSize: '12px',
                      color: '#000000',
                      padding: '10px',
                      borderRight: '1px solid #A7A7A7'
                    }}>
                      {new Date(member.date_of_birth).toLocaleDateString()}
                    </td>
                    <td style={{
                      fontFamily: 'open sans',
                      fontSize: '12px',
                      color: '#000000',
                      padding: '10px',
                      borderRight: '1px solid #A7A7A7',
                      textAlign: 'right',
                      fontWeight: '600'
                    }}>
                      {currencyCode} {((member.premium_amount_in_cents || 0) / 100).toFixed(2)}
                    </td>
                    <td style={{
                      fontFamily: 'open sans',
                      fontSize: '12px',
                      color: '#000000',
                      padding: '10px',
                      borderRight: '1px solid #A7A7A7'
                    }}>
                      {canPromote ? (
                        <ButtonInc
                          style={{ cursor: 'pointer' }}
                          onClick={() => onPromoteToPrincipal(member)}
                        >
                          Promote to Principal
                        </ButtonInc>
                      ) : (
                        <span
                          style={{ color: '#999', fontSize: '11px' }}
                          title={eligibilityCheck.reason}
                        >
                          Cannot promote
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      )}

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '30px' }}>
        <ButtonInc
          btnType="secondary"
          onClick={onCancel}
          style={{ border: '1px solid #032A37' }}
        >
          Cancel
        </ButtonInc>
        <ButtonInc
          btnType="primary"
          onClick={onNext}
        >
          Next
        </ButtonInc>
      </div>
    </div>
  );
};

export default DowngradeSelectionScreen;
